import { render, staticRenderFns } from "./IRSReportComponent.vue?vue&type=template&id=6a14b694&scoped=true"
import script from "./IRSReportComponent.vue?vue&type=script&lang=ts"
export * from "./IRSReportComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a14b694",
  null
  
)

export default component.exports